import React from "react";

import { borderRadius, color, spacing } from "minimum-ui/tokens";
import styled from "styled-components";

import { Typography } from "../Typography/Typography";

interface Props {
  title: string;
  instructions: string[] | React.ReactNode;
  maxWidth?: string;
}

export const InstructionBanner: React.FC<Props> = ({
  title,
  instructions,
  maxWidth = "500px",
}) => {
  return (
    <Wrapper $maxWidth={maxWidth}>
      <Typography variant="titleMedium">{title}</Typography>

      {Array.isArray(instructions) ? (
        <InstructionList>
          {instructions.map((instruction, index) => (
            <li key={index}>
              <Typography variant="bodyLarge">{instruction}</Typography>
            </li>
          ))}
        </InstructionList>
      ) : (
        instructions
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $maxWidth: string }>`
  border: 2px solid ${color.neutral[300]};
  border-radius: ${borderRadius.strong}rem;
  padding: ${spacing.xl}rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: ${color.basic.white};
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

const InstructionList = styled.ol`
  margin: 0;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
